import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack, MdModeEdit, MdAutorenew, MdLens } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { cardIssuerActions } from "./actions/cardissuers.actions";

import { Spinner, Placeholder } from "../Shared";
import { routeConstants } from "../../_constants";

export class CardIssuer extends Component {
  componentDidMount() {
    this.getCardIssuer();
  }

  componentWillUnmount() {
    this.props.resetCardIssuer();
  }

  getCardIssuer = () => {
    const { match } = this.props;
    if (match.params && match.params.id) {
      this.props.getCardIssuer(match.params.id);
    }
  };

  render() {
    const { match, response, fetching, error } = this.props;
    const cardIssuer = response && response.modelList[0];

    return (
      <div>
        <Row>
          <Col sm="6">
            <Link
              className="btn btn-outline btn-primary"
              to={routeConstants.CARDISSUERS.path}
            >
              <MdArrowBack /> Back to list
            </Link>
          </Col>
          <Col sm="6">
            <div className="text-right">
              <h5 className="item-count">
                <div>
                  Card Issuer: {cardIssuer && cardIssuer.name}{" "}
                  <Button
                    onClick={this.getCardIssuer}
                    color="primary"
                    outline
                    disabled={fetching}
                  >
                    {fetching ? (
                      <Spinner />
                    ) : (
                      <div>
                        <MdAutorenew size={20} />
                      </div>
                    )}
                  </Button>
                </div>
              </h5>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            {error && (
              <Alert color="danger">
                <strong>Error:</strong> {error.message}
              </Alert>
            )}
            <dl className="row">
              {/* <dt className="col-sm-3">Card Issuer Id</dt>
              <dd className="col-sm-9">
                {cardIssuer ? (
                  cardIssuer.id
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd> */}

              <dt className="col-sm-3">Card Issuer Code</dt>
              <dd className="col-sm-9">
                {cardIssuer ? (
                  cardIssuer.issuerCode
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Card Issuer Name</dt>
              <dd className="col-sm-9">
                {cardIssuer ? (
                  cardIssuer.name
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Card Issuer CBN Code</dt>
              <dd className="col-sm-9">
                {cardIssuer ? (
                  cardIssuer.issuerCbnCode
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Card Issuer IIN</dt>
              <dd className="col-sm-9">
                {cardIssuer ? (
                  cardIssuer.issuerNr
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Bank Code</dt>
              <dd className="col-sm-9">
                {cardIssuer ? (
                  cardIssuer.bankCode
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Card Issuer Nr</dt>
              <dd className="col-sm-9">
                {cardIssuer ? (
                  cardIssuer.issuerIin
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Card Issuer Status</dt>
              <dd className="col-sm-9">
                {cardIssuer ? (
                  cardIssuer.enabled ? (
                    <span>
                      <MdLens className="text-success" /> Enabled
                    </span>
                  ) : (
                    <span>
                      <MdLens className="text-danger" /> Disabled
                    </span>
                  )
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>
            </dl>
            <Link
              className="btn btn-primary"
              to={`${routeConstants.CARDISSUERS.path}/edit/${match.params.id}`}
            >
              <MdModeEdit /> Edit
            </Link>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, request, response, error } = state.viewCardIssuer;
  return {
    fetching,
    fetched,
    request,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCardIssuer: bindActionCreators(
      cardIssuerActions.getCardIssuer,
      dispatch
    ),
    resetCardIssuer: bindActionCreators(
      cardIssuerActions.resetCardIssuer,
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CardIssuer);
